import React, { useEffect, useState } from 'react';

import Modal from '../common/Modal';
 // Import the CSS file for styling

import { useVoiceApi } from '../../auth/helper/api/voiceApi';

const VoiceCategoryPage = () => {
  
  

  const voiceApi = useVoiceApi();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newCategory, setNewCategory] = useState({
    templateCategory: '',
    status: false,
  });

  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    templateCategory: null,
    status: null,  
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  useEffect(() => {
    
    const fetchCategories = async () => {
      try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_CATEGORIES_BY_PAGE_ENDPOINT,
          {
            params: {...filters,
              page,
              size,
            },
          }
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setCategories(object.content); // Set the categories from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);
      }
    };

    fetchCategories();
  }, [ voiceApi, page, size]);

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;

    setNewCategory((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value, // Use checked for checkbox type
    }));
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      return newFilters;
    });
  };


  const toggleActivationStatus = async (categoryId, currentStatus) => {
    
    try {
      const newStatus = !currentStatus; // Toggle the current status
      await voiceApi.patch(
        `${process.env.REACT_APP_SET_VOICE_CATEGORY_STATUS_ENDPOINT}/${categoryId}`,
        { status: newStatus }
      );
      setCategories((prev) =>
        prev.map((category) => category.id === categoryId ? { ...category, status: newStatus } : category)
      );
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };


  const handleSubmit = async (e) => {
    
    e.preventDefault();
    try {
      const response = await voiceApi.post(
        `${process.env.REACT_APP_SET_VOICE_CATEGORY_ENDPOINT}`,
           newCategory
      );
      if (response.status === 200) {
        setCategories((prev) => [...prev, response.data.object]); // Update with new category
        setNewCategory({ templateCategory: '', status: true }); // Reset form
        setError(null);
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the category.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {
    
    setLoading(true); // Show loading while fetching filtered notifications
    try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_CATEGORIES_BY_PAGE_ENDPOINT,
          {
            params: {...filters,
              page,
              size,
            },
          }
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setCategories(object.content); // Set the categories from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);
      }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading categories: {error}</div>;

  return (
    <div className="category-container">
      <h2>Voice Categories</h2>
       <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>

       <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
         <div className="filter-item">
          <label>Id:</label>
          <input
              type="text"
              name="id"
              value={filters.id ?? ''}
              onChange={handleFilterInputChange}
            />
        </div>

        <div className="filter-item">
          <label>TemplateCategory:</label>
          <input
              type="text"
              name="templateCategory"
              value={filters.templateCategory ?? ''}
              onChange={handleFilterInputChange}
            />
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>
      
       {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
         <div className="page-container">
          <form onSubmit={handleSubmit} className="standard-form">
            <h3>Create New Voice Category</h3>
            <div className="form-group">
              <label>Voice Category:</label>
              <input
                type="text"
                name="templateCategory"
                value={newCategory.templateCategory}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="status"
                checked={newCategory.status}
                onChange={handleInputChange}
              />
            </div>
                    <button type="submit">Create Category</button>
          </form>
        </div>
      </Modal>

      <h3>Existing Voice Categories</h3>
      {categories.length === 0 ? (
        <p>No categories available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Category Name</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr key={category.id}>
                  <td>{category.id}</td>
                  <td>{category.templateCategory}</td>
                  <td>{new Date(category.createdTimestamp).toLocaleString()}</td>
                  <td>{category.status ? 'Active' : 'Inactive'}</td>
                  <td>{new Date(category.updatedTimestamp).toLocaleString()}</td>
                  <td>{category.lastUpdatedBy}</td>
                  <td>
                    <button onClick={() => toggleActivationStatus(category.id, category.status)}>
                      {category.status ? 'Disable' : 'Enable'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default VoiceCategoryPage;